<tr [formGroup]="detalleFormGroup" #localDetalleForm="ngForm">
    <td class="d-none d-md-table-cell">{{detalleNumero}}</td>
    <td class="d-none d-md-table-cell" WIDTH="12%">
        <div class="form-group">

            <div class="row">

                <div class="col-12" style="overflow: visible;">
                    <!-- <input type="text" class="form-control"  name="codigo" formControlName="codigo" (blur)="onSubmit()"> -->
                    <!-- <ng-select
                        formControlName="codigo"
                        [items]="searchCatalog"
                        [selectOnTab]="true"
                        [loading]="searchLoading"
                        bindLabel="codigoBarra"
                        placeholder="Ingrese código de barra"
                        (change)="refreshItemDetail($event)"
                        (search)="searchItem($event,'codigoBarra')"
                        addTagText="Agregar producto"
                        [addTag]="AddProductByCode"
                        notFoundText="Sin resultado"
                        ></ng-select> -->
                    <input type="text" class="form-control" formControlName="codigo">
                    <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.codigo.invalid"
                        class="text-danger">
                        <div *ngIf="detalleFormGroup.controls.codigo.errors?.required">Campo Requerido</div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="showInExport" [ngClass]="{
                'mt-2':opciones.tipoMoneda=='CLP',
                'mt-5': opciones.tipoMoneda!='CLP'
            }">
                <div class="col">
                    <label for="" class="label-control font-weight-bold">Bulto Asociado</label>
                    <ng-select [items]="exportPackages" notFoundText="Sin bultos declarados" bindLabel="localIndex"
                        (change)="setDetailFromPackage($event)"></ng-select>
                </div>
            </div>
        </div>
    </td>

    <!-- product based item input -->
    <td WIDTH="40%" class="nombre-item">
        <div class="form-group">
            <!-- <input type="text" class="form-control" name="nombreItem" formControlName="nombreItem" (blur)="onSubmit()"> -->
            <!-- <ng-select
                    formControlName="nombreItem"
                    [items]="searchCatalog"
                    [selectOnTab]="true"
                    [loading]="searchLoading"
                    bindLabel="nombre"
                    placeholder="Ingrese nombre"
                    (change)="refreshItemDetail($event)"
                    (search)="searchItem($event,'nombre')"
                    addTagText="Agregar Producto"
                    [addTag]="AddProductByName"
                    notFoundText="Sin resultado"
                ></ng-select> -->
            <input type="text" class="form-control text-nombre"  formControlName="nombreItem" placeholder="Nombre del Producto" (blur)="onSubmit()"
            [ngClass]="{
                'is-invalid': detalleFormGroup.controls.nombreItem.invalid && detalleFormGroup.controls.nombreItem.touched
            }">
            <label for="nombreItem" class="label-nombre">Nombre Producto</label>
            <!--<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.nombreItem.invalid" class="text-danger">
                <div *ngIf="detalleFormGroup.controls.nombreItem.errors?.required">Campo Requerido</div>
            </div>-->
            <div class="row" *ngIf="detalleFormGroup.controls.haveDescripcion.value && showingDetails" [ngClass]="{
                    'mt-2':opciones.tipoMoneda=='CLP',
                    'mt-4':opciones.tipoMoneda!='CLP'
                }">
                <div class="col-9" style="overflow: visible;">
                    <label for="" class="label-control font-weight-bold">Descripción</label>
                    <textarea type="text" class="form-control" name="descripcion" formControlName="descripcion"
                        (blur)="onSubmit()" rows="2" cols="90" style="overflow: visible; width: 136%;"></textarea>
                    <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.descripcion.invalid"
                        class="text-danger">
                        <div *ngIf="detalleFormGroup.controls.descripcion.errors?.required">Campo Requerido</div>
                    </div>
                </div>
            </div>
        </div>
    </td>

    <td class="d-none d-md-table-cell" *ngIf="showingDetails">
        <div class="form-group">
            <div class="row pl-5 mb-4">
                <div class="ml-5">
                    <input type="checkbox" class="form-check-input" name="haveDescripcion"
                        formControlName="haveDescripcion" (change)="changeHaveDescripcion($event)" (blur)="onSubmit()">
                </div>
            </div>
        </div>
    </td>

    <td WIDTH="12%" class="text_cantidad">
        <div class="form-group">
            <input style="text-indent: 5px; padding-left: 0px;" type="number" class="form-control cantidad" min="0.1"
                name="cantidad" formControlName="cantidad" (blur)="onSubmit()">
                <label for="nombreItem" class="label-cantidad">Cantidad</label>
            <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.cantidad.invalid" class="text-danger">
                <div *ngIf="detalleFormGroup.controls.cantidad.errors?.required">Campo Requerido</div>
                <div *ngIf="detalleFormGroup.controls.cantidad.errors?.PositiveNumber">Número debe ser positivo</div>
            </div>

            <div class="row " *ngIf="detalleFormGroup.controls.haveDescripcion.value && showingDetails" [ngClass]="{
                'mt-1':opciones.tipoMoneda=='CLP',
                'mt-0':opciones.tipoMoneda!='CLP'
            }">
                <div class="col-12 pt-2" style="overflow: visible;" *ngIf="currentInvoiceType == InvoiceType.Factura">
                    <div class="form-group">
                        <label for="" class="label-control font-weight-bold mb-1"  ngbTooltip="Rebaja por avalúo fiscal.">Rebaja Avalúo</label>
                        <input type="number" class="form-control padding-unidad-medida" name="rebajaAvaluo"
                        formControlName="rebajaAvaluo" (blur)="onSubmit()" [min]="0" style="overflow: visible; width: 100%;">
                    </div>
                </div>
            </div>
            <div class="row " *ngIf="detalleFormGroup.controls.haveDescripcion.value && showingDetails" [ngClass]="{
                'mt-1':opciones.tipoMoneda=='CLP',
                'mt-10':opciones.tipoMoneda!='CLP'
            }">
                <div class="col-12" style="overflow: visible;">
                    <div class="form-group">
                        <label for="" class="label-control font-weight-bold mb-1">Tipo Codigo</label>
                        <input type="text" class="form-control" name="tpoCodigo"
                            formControlName="tpoCodigo" (blur)="onSubmit()"
                            style="overflow: visible; width: 100%;" maxlength="10" ngbTooltip="máximo 10 caracteres">
                        <div *ngIf="detalleFormGroup.controls.tpoCodigo.invalid && detalleFormGroup.controls.tpoCodigo.touched" class="text-danger">
                            <div *ngIf="detalleFormGroup.controls.tpoCodigo.errors?.maxlength">Máximo 10 caracteres</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </td>

    <td WIDTH="12%">
        <div class="form-group">
            <input style="text-indent: 3px; padding-left: 0px;" type="number" class="form-control precioUnitario" min="0"
                name="precioUnitario" formControlName="precioUnitario" (blur)="onSubmit()"
                [ngClass]="{
                    'is-invalid': detalleFormGroup.controls.precioUnitario.invalid && detalleFormGroup.controls.precioUnitario.touched
                }">
                <label for="nombreItem" class="label-precioU">Precio u.</label>
            <div class="clp-equivalent text-right mt-3" *ngIf="opciones.tipoMoneda!='CLP'">

                <div class="float-left">
                    CLP
                </div>
                <div class="float right">
                    {{this.subPrice | number:'1.0-3':'es'}}
                </div>
            </div>
            <!--<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.precioUnitario.invalid"
                class="text-danger">
                <div *ngIf="detalleFormGroup.controls.precioUnitario.errors?.required">Campo Requerido</div>
                <div *ngIf="detalleFormGroup.controls.precioUnitario.errors?.PositiveNumber">Número debe ser positivo
                </div>
            </div>  -->

            <div class="row " *ngIf="detalleFormGroup.controls.haveDescripcion.value && showingDetails" [ngClass]="{
                'mt-1':opciones.tipoMoneda=='CLP',
                'mt-0':opciones.tipoMoneda!='CLP'
            }">
                <div class="col-12 pt-2" style="overflow: visible;">
                    <div class="form-group">
                        <label for="" class="label-control font-weight-bold mb-1">Unidad Medida</label>
                        <input type="text" class="form-control padding-unidad-medida" name="unidadMedida"
                            formControlName="unidadMedida" (blur)="onSubmit()" style="overflow: visible; width: 100%;">
                        <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.unidadMedida.invalid"
                            class="text-danger">
                            <div *ngIf="detalleFormGroup.controls.unidadMedida.errors?.required">Campo Requerido</div>
                        </div>
                    </div>
                </div>
            </div>
             
            <div class="row" *ngIf="detalleFormGroup.controls.haveDescripcion.value && showingDetails" [ngClass]="{
                'mt-1':opciones.tipoMoneda=='CLP',
                'mt-0':opciones.tipoMoneda!='CLP'
            }">
                <div class="col-12" style="overflow: visible;">
                    <div class="form-group">
                        <label for="" class="label-control font-weight-bold mb-1 text-nowrap">Valor Codigo</label>
                        <input type="text" class="form-control" name="vlrCodigo"
                            formControlName="vlrCodigo" (blur)="onSubmit()" style="overflow: visible; width: 100%;" maxlength="35"
                            ngbTooltip="máximo 35 caracteres">
                        <div *ngIf="detalleFormGroup.controls.vlrCodigo.invalid && detalleFormGroup.controls.vlrCodigo.touched" class="text-danger">
                            <div *ngIf="detalleFormGroup.controls.vlrCodigo.errors?.maxlength">Máximo de caracteres: 35</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </td>

    <td class="d-none d-md-table-cell">
        <div class="form-group">
            <input style="text-indent: 5px; padding-left: 0px;" type="number" class="form-control"
                name="descuentoRecargo" formControlName="descuentoRecargo" (blur)="onSubmit()"
                ngbTooltip="Valores Negativos indican descuentos y positivos indican recargos">
            <div class="clp-equivalent text-right mt-3" *ngIf="opciones.tipoMoneda!='CLP'">
                <div class="float-left">
                    CLP
                </div>
                <div class="float-right">
                    {{this.subDiscount | number:'1.0-2':'es'}}
                </div>
            </div>
            <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.descuentoRecargo.invalid"
                class="text-danger">
                <div *ngIf="detalleFormGroup.controls.descuentoRecargo.errors?.required">Campo Requerido</div>
            </div>
        </div>
    </td>

    <td *ngIf="!hideExentoColumn" class="ml-5 text-center">
        <div class="form-group ml-5">
            <!--deshabilitar el checkbox si el producto tiene impuestos-->
            <input type="checkbox" class="form-check-input exento" name="exento" formControlName="exento" 
                (change)="onExentoChange($event)"
                [disabled]="isExentoDisabled"
                [ngClass]="{'disabled-opacity': isExentoDisabled}"
                [disabled]="(currentProduct?.impuestos?.length > 0) || (selectedTaxes.length > 0)"
                [ngbTooltip]="getExentoTooltipMessage()">    
                <label for="nombreItem" class="label-exento">Exento</label>
        </div>
    </td>
    <td class="ml-5 text-center" *ngIf="currentInvoiceType != InvoiceType.FacturaExportacion && currentInvoiceType != InvoiceType.FacturaCompra"> 
        <div class="form-group impuestos">
          <span class="btn-icon"
            [ngbTooltip]="getTaxTooltipMessage()"
            [ngClass]="{'disabled-opacity': isTaxButtonDisabled}"
            (click)="isTaxButtonDisabled ? null : openTaxModal(taxModal)">
            <i class="fa-duotone fa-solid fa-circle-plus fa-2xl mt-3 btn-impuesto"
               style="--fa-primary-color: #ffffff; --fa-secondary-color: #1624a3;"></i>
          </span>
        </div>
    </td>
    <td WIDTH="2%" *ngIf="currentInvoiceType == InvoiceType.FacturaCompra">
        <div class="form-group ml-2" style="max-width:50px;">
            <div class="row mb-5" style="width:30%">
                <div class="col-12">
                    <input type="checkbox" class="ml-0 form-check-input" name="haveRetencion"
                        formControlName="haveRetencion"  ngbTooltip="Indicar porcentaje de retención" (change)="changeRetencionInput($event)">
                </div>
            </div>

            <div class="row pt-5" *ngIf="showRetencionPercent">
                <div class="col-12 pl-0">
                    <input type="number" min="0" [max]="porcentajeIva*100" class="form-control"
                        name="retencionPorcentaje" formControlName="retencionPorcentaje" (blur)="onSubmit()">
                    <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.retencionPorcentaje.invalid"
                        class="text-danger">
                        <div *ngIf="detalleFormGroup.controls.retencionPorcentaje.errors?.numberIsHigher"
                            class="unbreakable-words">Excede máximo {{porcentajeIva*100}}%</div>
                    </div>
                </div>
            </div>

            <div class="row mt-5 mx-0" *ngIf="showRetencionPercent" style="overflow: visible;">
                <div class="col-12 pl-0">
                    <ng-select formControlName="retencionTipo" [items]="retencionesSource" [selectOnTab]="true"
                        bindLabel="nombre" placeholder="Seleccione retención" class="overflow-select"
                        (change)="getRetencionChanges($event)"></ng-select>
                </div>

                <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.retencionTipo.invalid"
                    class="text-danger">
                    <div *ngIf="detalleFormGroup.controls.retencionTipo.errors?.required" class="unbreakable-words">
                        Campo requerido</div>
                </div>
            </div>
        </div>
    </td>
    <td WIDTH="12%">
        <div class="float-right" style="width:100%">
            <div class="alter-equivalent text-right mb-5 pt-1" *ngIf="opciones.tipoMoneda != 'CLP'">
                <div class="mb-5">
                    <div class="float-left"
                    *ngIf="((currentProduct?.impuestos?.length > 0) || (selectedTaxes.length > 0)) && currentInvoiceType != InvoiceType.FacturaExportacion">
                        <fa-icon icon="exclamation-triangle" class="fa-lg text-warning" [ngbTooltip]="list"></fa-icon>
                    </div>
                    <div class="float-right">
                        {{totalForeign | number:'1.0-2':'es'}}

                    </div>
                </div>
                <div class="text-right mt-6 pt-6 pt-1">
                    <div class="float-left mt-1">
                        CLP
                    </div>
                    <div class="float-right mt-1">
                        {{detalleDte.total | number:'1.0-2':'es'}}
                    </div>
                </div>
            </div>
            <!-- <input type="number" class="form-control" name="subtotal" formControlName="subtotal" (blur)="onSubmit()"> -->
            <div class="text-right" *ngIf="opciones.tipoMoneda == 'CLP'">
                <div class="float-left"
                *ngIf="((currentProduct?.impuestos?.length > 0) || (selectedTaxes.length > 0)) && currentInvoiceType != InvoiceType.FacturaExportacion">
                    <fa-icon icon="exclamation-triangle" class="fa-lg text-warning" [ngbTooltip]="list"></fa-icon>
                </div>
                <!--subtotal-->
                <div class="float-right">
                    {{detalleDte.total | number:'1.0-2':'es'}}
                </div>
                <label for="subtotal" class="label-Subtotal">Subtotal</label>
            </div>
        </div>
    </td>
    <td>
        <button class="btn btn-danger btn_delete" (click)="deleteItem()">
            <i class="flaticon-delete"></i>
        </button>
    </td>

</tr>
<ng-template #list>
    <div class="d-flex flex-column">
        <b class="text-danger" *ngIf="opciones.tipoMoneda=='USD' && currentInvoiceType== InvoiceType.FacturaExportacion">
            No considerado
        </b>
        <b>Impuestos</b>
        
        <!-- Impuestos del Producto -->
        <span *ngIf="currentProduct?.impuestos?.length > 0">
            <span *ngFor="let tax of currentProduct.impuestos">
                • {{ tax.nombre }}, {{ tax.valor }} %
            </span>
        </span>

        <!-- Impuestos Adicionales -->
        <span *ngIf="taxesSource?.length > 0">
               {{getTaxTooltip()}} 
        </span>
    </div>
</ng-template>



<!-- Modal para seleccionar impuestos -->
<ng-template #taxModal let-modal>
    <div class="modal-header">
        <div>
            <h5 class="modal-title">Seleccionar Impuestos</h5>
            <div *ngIf="currentProduct?.impuestos?.length === 1 && currentInvoiceType != InvoiceType.FacturaCompra" style="background-color: transparent; color: #0000006c; border: none;">
                <!--Colocar el nombre del impuesto
                {{ currentProduct?.impuestos[0]?.nombre }} ya está aplicado a este producto.-->
                Este producto ya tiene 1 impuesto; solo puedes añadir 1 más. 

            </div>
            <div *ngIf="!currentProduct?.impuestos?.length && currentInvoiceType != InvoiceType.FacturaCompra"  style="background-color: transparent; color: #0000006c; border: none;">
                Puedes agregar hasta 2 impuestos.
            </div>
        </div>
          <button type="button" class="close" (click)="modal.dismiss('Cross click')">×</button>
    </div>
    
    <div class="modal-body">
        <div *ngFor="let tax of taxesSource" class="form-check">
            <input 
                type="checkbox" 
                [(ngModel)]="tax.selected"
                [disabled]="!tax.selected && isTaxSelected() || selectImpuestoTrue(tax)"
                class="form-check-input"
                id="tax-{{ tax.impuestoId }}">
            <label class="form-check-label" for="tax-{{ tax.impuestoId }}">
                {{ tax.nombre }} - ({{ tax.valor }}%)
                <span *ngIf="selectImpuestoTrue(tax)"> (Aplicado) </span>
            </label>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="applyTaxChanges(); modal.close()">Guardar</button>
    </div>
</ng-template>
